import { render, staticRenderFns } from "./etablissement-card.vue?vue&type=template&id=42e72b30&scoped=true&"
import script from "./etablissement-card.vue?vue&type=script&lang=ts&"
export * from "./etablissement-card.vue?vue&type=script&lang=ts&"
import style0 from "./etablissement-card.vue?vue&type=style&index=0&id=42e72b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e72b30",
  null
  
)

export default component.exports